// api/cardSections.ts — director config + employee fill for custom deal-card
// sections (app-native, per-funnel). Template GET/PUT is director-only.
import { apiRequest } from './client'

export type CardSectionType = 'text' | 'files'

// A section in the funnel template (director config screen).
export interface CardSectionDef {
  key: string
  label: string
  type: CardSectionType
  order: number
}

export interface CardSectionsResponse {
  pipeline_id: string
  sections: CardSectionDef[]
}

// What we send on save — `key` omitted for a brand-new section.
export interface CardSectionInput {
  key?: string
  label: string
  type: CardSectionType
}

function enc(id: string): string {
  return encodeURIComponent(id)
}

export function fetchCardSections(pipelineId: string): Promise<CardSectionsResponse> {
  return apiRequest<CardSectionsResponse>(
    `/api/miniapp/deals/funnels/${enc(pipelineId)}/sections`,
  )
}

export function saveCardSections(
  pipelineId: string,
  sections: CardSectionInput[],
): Promise<CardSectionsResponse> {
  return apiRequest<CardSectionsResponse>(
    `/api/miniapp/deals/funnels/${enc(pipelineId)}/sections`,
    { method: 'PUT', body: { sections } },
  )
}

// Employee fill: set (or clear with '') a deal's text-section value.
export function setDealSectionValue(
  dealId: number,
  sectionKey: string,
  value: string,
): Promise<{ ok: boolean }> {
  return apiRequest<{ ok: boolean }>(
    `/api/miniapp/deals/${dealId}/sections/${enc(sectionKey)}`,
    { method: 'PUT', body: { value } },
  )
}
